import { z } from "zod";

export const PROJECT_SUGGESTIONS_ROUTE_ID =
  "/_authenticated/orgs/$organizationId/projects/$projectId/suggestions" as const;

export const PROJECT_SUGGESTIONS_PAGE_SIZES = [25, 50, 100] as const;

export const PROJECT_SUGGESTIONS_DEFAULT_PAGE_SIZE = 50;

export const projectSuggestionsSearchSchema = z.object({
  /** Gateways to include; empty means every gateway in the project. */
  gateway_id: z.array(z.string()).catch([]).default([]),
  /** Submitter user IDs to include; empty means every submitter. */
  suggestion_submitter: z.array(z.string()).catch([]).default([]),
  query: z.string().catch("").default(""),
  show_resolved: z.boolean().catch(false).default(false),
  limit: z
    .number()
    .int()
    .min(1)
    .max(PROJECT_SUGGESTIONS_PAGE_SIZES.at(-1) ?? 100)
    .catch(PROJECT_SUGGESTIONS_DEFAULT_PAGE_SIZE)
    .default(PROJECT_SUGGESTIONS_DEFAULT_PAGE_SIZE),
  offset: z.number().int().nonnegative().catch(0).default(0),
});

export type ProjectSuggestionsSearch = z.infer<
  typeof projectSuggestionsSearchSchema
>;

export const projectSuggestionsSearchDefaults: ProjectSuggestionsSearch = {
  gateway_id: [],
  suggestion_submitter: [],
  query: "",
  show_resolved: false,
  limit: PROJECT_SUGGESTIONS_DEFAULT_PAGE_SIZE,
  offset: 0,
};
